import React from "react";
import { ScheduleView } from "./scheduleTypes";

interface ViewTabsProps {
  value: ScheduleView;
  onChange: (view: ScheduleView) => void;
}

const TABS: { value: ScheduleView; label: string }[] = [
  { value: "list", label: "List" },
  { value: "weekly", label: "Week" },
  { value: "monthly", label: "Month" },
  { value: "year", label: "Year" },
];

const ViewTabs: React.FC<ViewTabsProps> = ({ value, onChange }) => {
  return (
    <div className="flex items-center gap-1 rounded-lg bg-base-300/60 p-1 w-full">
      {TABS.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            type="button"
            onClick={() => onChange(tab.value)}
            className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium font-grotesk transition-colors ${
              active
                ? "bg-base-100 text-base-content shadow-sm"
                : "text-base-content/50 hover:text-base-content/80"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default ViewTabs;
